export const CRITERION_KEY = {
  availability: 'AVAILABILITY',
  mobility: 'MOBILITY',
  regexid: 'REGEXID',
  position: 'POSITION',
  license: 'LICENSE',
  duration: 'DURATION',
  contract: 'CONTRACT',
};
